import { Items } from "./Items"
import { Map } from "./Map"
import { RecordCreate } from "./RecordCreate"

/**
 * Maps values of a record while preserving keys.
 * Applies a transformation function to each value.
 *
 * @param valueFn - Function to transform values (receives value and key)
 * @param input - Source record object
 * @returns New record with transformed values, same keys
 *
 * @example
 * ```ts
 * import { RecordMap } from "@pdfking/tfunc"
 *
 * const input = { a: 1, b: 2, c: 3 }
 * const result = RecordMap(v => v * 10, input)
 * // { a: 10, b: 20, c: 30 }
 * ```
 */
export const RecordMap = <
  T extends Record<string, any>,
  V extends T[keyof T],
  NV,
>(
  valueFn: (value: V, key: string) => NV,
  input: T
): { [K in keyof T]: NV } =>
  RecordCreate(Map(([k, v]) => [k, valueFn(v as V, k)], Items(input))) as {
    [K in keyof T]: NV
  }
